import { render, staticRenderFns } from "./updateNew.vue?vue&type=template&id=c333b454&scoped=true"
import script from "./updateNew.vue?vue&type=script&lang=js"
export * from "./updateNew.vue?vue&type=script&lang=js"
import style0 from "./updateNew.vue?vue&type=style&index=0&id=c333b454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c333b454",
  null
  
)

export default component.exports